export { DetailsViewPoints } from './DetailsViewPoints';
